import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../utils";
import { AttorneyPurchaseItemGetResponse } from "../../../../api/src/admin/purchase-items/route";
import type {
  PayoutPurchaseItemPostRequest,
  PayoutPurchaseItemPostResponse,
} from "../../../../api/src/stripe/route";

export const attorneyPayoutsApi = createApi({
  reducerPath: "attorneyPayoutsApi",
  baseQuery,
  tagTypes: ["AttorneyPayouts", "PayoutResult"],
  endpoints: (builder) => ({
    getAttorneyPayouts: builder.query<
      AttorneyPurchaseItemGetResponse,
      "due" | "paid"
    >({
      query: (paymentStatus) => ({
        url: "admin/purchase-items",
        method: "GET",
        params: {
          paymentStatus,
        },
      }),
      providesTags: ["AttorneyPayouts"],
    }),
    payoutPurchaseItem: builder.mutation<
      PayoutPurchaseItemPostResponse,
      PayoutPurchaseItemPostRequest
    >({
      query: ({
        purchase_item_id,
        amountCents,
        partialPayoutReason,
        skipStripeTransfer,
        allowTransferWithoutCharge,
      }) => ({
        url: "stripe/payout-purchase-item",
        method: "POST",
        body: {
          purchase_item_id,
          ...(amountCents !== undefined ? { amountCents } : {}),
          ...(partialPayoutReason ? { partialPayoutReason } : {}),
          ...(skipStripeTransfer ? { skipStripeTransfer } : {}),
          ...(allowTransferWithoutCharge ? { allowTransferWithoutCharge } : {}),
        },
      }),
      invalidatesTags: ["AttorneyPayouts", "PayoutResult"],
    }),
  }),
});

export const { useGetAttorneyPayoutsQuery, usePayoutPurchaseItemMutation } =
  attorneyPayoutsApi;
